import React from 'react';
import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldValues,
  UseControllerOptions,
} from 'react-hook-form';
import SelectInput from './SelectInput';
import { getFieldErrorMessages } from './utilities/form-tools';
import { InputPropsFor } from './utilities/input.types';

export default function FormSelectInput<F extends FieldValues>({
  controlName,
  optional,
  rules = {},
  control,
  errors,
  defaults,
  classicPlaceholder,
  ...props
}: InputPropsFor<'SelectInput', F>): JSX.Element {
  const controller: UseControllerOptions = {
    control: control as Control,
    name: controlName,
    defaultValue: defaults?.[controlName] || '',
    rules: {
      required: optional ? undefined : 'Required',
      ...rules,
    },
  };

  const errorObj = errors[controlName];
  const errorText = getFieldErrorMessages(errorObj);

  const SelectFieldComponent = ({
    ref,
    ...controllerRenderProps
  }: Partial<ControllerRenderProps> = {}) => (
    <>
      <SelectInput
        greyPlaceholder={!classicPlaceholder}
        inputRef={ref}
        {...{ errorText }}
        {...controllerRenderProps}
        {...props}
      />
    </>
  );

  return <Controller render={SelectFieldComponent} {...controller} />;
}
